import {
  CheckCircle,
  DirectionsCar,
  HighlightOff,
  Loop,
  WhereToVote,
  Task,
  Assignment,
  Cancel,
  RunningWithErrors,
} from '@mui/icons-material';
import { Box, Chip, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../common/enums/enums';
import { MechanicStatusChip } from './WorkOrderForVehicle/icons/MechanicStatusChip';
import { MoveToWholeSale } from './WorkOrderForVehicle/icons/MoveToWholeSale';

const PREFIX = 'StepperButton';

const classes = {
  icons: `${PREFIX}-icons`,
  chipText: `${PREFIX}-chipText`,
  generated: `${PREFIX}-generated`,
  approved: `${PREFIX}-approved`,
  inTransit: `${PREFIX}-inTransit`,
  inProcess: `${PREFIX}-inProcess`,
  arrived: `${PREFIX}-arrived`,
  paused: `${PREFIX}-paused`,
  canceled: `${PREFIX}-canceled`,
  declined: `${PREFIX}-declined`,
  done: `${PREFIX}-done`,
  mechanical: `${PREFIX}-mechanical`,
  wholesale: `${PREFIX}-wholesale`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.chipText}`]: {
    backgroundColor: 'transparent',
    height: '24px',
  },

  [`& .${classes.generated}`]: {
    color: theme.palette.info.main,
  },

  [`& .${classes.approved}`]: {
    color: theme.palette.primary.main,
  },

  [`& .${classes.inTransit}`]: {
    color: theme.palette.primary.dark,
  },

  [`& .${classes.inProcess}`]: {
    color: theme.palette.warning.main,
  },

  [`& .${classes.arrived}`]: {
    color: '#0D3C61',
  },

  [`& .${classes.paused}`]: {
    color: theme.palette.warning.dark,
  },

  [`& .${classes.canceled}`]: {
    color: theme.palette.error.main,
  },

  [`& .${classes.declined}`]: {
    color: theme.palette.error.main,
  },

  [`& .${classes.done}`]: {
    color: theme.palette.success.main,
  },
  [`& .${classes.mechanical}`]: {
    color: '#616161',
  },
  [`& .${classes.wholesale}`]: {
    color: '#E31B0C',
  },
}));

const iconStyles = {
  color: 'inherit',
  width: '18px',
  height: '18px',
  ml: '0px',
  mr: '-4px',
};

const StepperStatusChip = ({ step }) => {
  const { t } = useTranslation('workOrdersTable');

  const getOrderStep = (stepClass, label, icon) => (
    <Grid item>
      <Box>
        <Chip
          className={`${classes.chipText} ${stepClass}`}
          label={label}
          sx={{
            '& .MuiChip-icon': {
              ...iconStyles,
            },
          }}
          icon={icon}
        />
      </Box>
    </Grid>
  );

  const getStepConfig = processStep => {
    switch (processStep) {
      case ProcessStep.GENERATED:
        return {
          class: classes.generated,
          label: t('card.stepStates.generated'),
          icon: <Assignment />,
        };
      case ProcessStep.APPROVED:
        return {
          class: classes.approved,
          label: t('card.stepStates.approved'),
          icon: <Task />,
        };
      case ProcessStep.IN_TRANSIT:
        return {
          class: classes.inTransit,
          label: t('card.stepStates.intransit'),
          icon: <DirectionsCar />,
        };
      case ProcessStep.ARRIVED:
        return {
          class: classes.arrived,
          label: t('card.stepStates.arrived'),
          icon: <WhereToVote />,
        };
      case ProcessStep.IN_PROCESS:
        return {
          class: classes.inProcess,
          label: t('card.stepStates.inprocess'),
          icon: <Loop />,
        };
      case ProcessStep.DONE:
        return {
          class: classes.done,
          label: t('card.stepStates.done'),
          icon: <CheckCircle />,
        };
      case ProcessStep.PAUSED:
        return {
          class: classes.paused,
          label: t('card.stepStates.paused'),
          icon: <RunningWithErrors />,
        };
      case ProcessStep.CANCELED:
        return {
          class: classes.canceled,
          label: t('card.stepStates.canceled'),
          icon: <Cancel />,
        };
      case ProcessStep.DECLINED:
        return {
          class: classes.declined,
          label: t('card.stepStates.declined'),
          icon: <HighlightOff />,
        };
      case ProcessStep.MECHANICAL:
        return {
          class: classes.mechanical,
          label: t('card.stepStates.mechanical'),
          icon: <MechanicStatusChip color="#616161" />,
        };
      case ProcessStep.WHOLE_SALE:
        return {
          class: classes.wholesale,
          label: t('card.stepStates.wholesale'),
          icon: <MoveToWholeSale color="#E31B0C" />,
        };
      default:
        return null;
    }
  };

  const stepConfig = getStepConfig(step);
  return (
    <StyledBox>
      <Grid container alignItems="center">
        {stepConfig &&
          getOrderStep(stepConfig.class, stepConfig.label, stepConfig.icon)}
      </Grid>
    </StyledBox>
  );
};

export default StepperStatusChip;
